import { computed, unref, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import Contact from "@/services/contact/contact";
import type { ContactEngagementSummary } from "@/dtos/Contact.dto";

export function useEngagementSummary(contactIds: Ref<string[]> | string[]) {
  const ids = computed(() => {
    const raw = unref(contactIds) || [];
    return [...new Set(raw.filter(Boolean))].sort();
  });

  const enabled = computed(() => ids.value.length > 0);

  return useQuery({
    queryKey: computed(() => ["engagement-summary", ids.value]),
    queryFn: async (): Promise<Record<string, ContactEngagementSummary>> => {
      const result = await Contact.getEngagementSummary(ids.value);
      if (result.data.status) {
        return result.data.data;
      }
      throw new Error(result.data.msg || "Failed to load engagement summary");
    },
    enabled,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
